module.exports = __webpack_public_path__ + "static/img/jia.3fd390fc.svg";